document.getElementById("myForm").addEventListener("submit", function (event) {
  event.preventDefault();

  var elements = this.elements;

  // const url = "http://localhost:3000/post";
  const url = "https://warpcode.fr/post";

  async function fetchData(elements) {
    const data = {
      name: elements["name"].value,
      phoneNumber: elements["phoneNumber"].value,
      email: elements["email"].value,
      sujet: elements["sujet"].value,
      message: elements["message"].value,
      politique: elements["politique"].checked,
    };

    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
      },
      body: JSON.stringify(data),
    };

    // console.log("fetchOptions", fetchOptions);

    try {
      document.getElementById("sendButton").disabled = true;
      document.getElementById("sendingStatus").innerText =
        "Statut : Message en cours d'envoi...";

      const response = await fetch(url, fetchOptions);

      const responseData = await response.json();
      // console.log("Réponse :", responseData);
      document.getElementById("sendingStatus").innerText =
        "Statut : Message envoyé depuis l'adresse " + responseData.ip;
      document.getElementById("sendingStatusBox").className =
        "emailSendingStatusSent";
    } catch (error) {
      document.getElementById("sendingStatusBox").className =
        "emailSendingStatusError";
      document.getElementById("sendingStatus").innerText =
        "Statut : Erreur, message non envoyé.";
      document.getElementById("sendButton").disabled = false;
      console.log("Il y a eu une erreur :\n", error);
    }
  }

  // Appel de la fonction fetchData avec les éléments du formulaire
  fetchData(elements);
});
